import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { appsettings } from '../shared/app.settings';
import 'rxjs/add/operator/map';

@Injectable()
export class SearchProductsService {

    constructor(private http: Http) { }

    getAll(country: string, language: string) {
        return this.http.get(appsettings.rootUrl + country + '/' + language + '/allproduct')
            .map((response: Response) => response.json());
    }

    getHighlightedText(country: string, language: string) {
        return this.http.get(appsettings.rootUrl + country + '/' + language + '/allproduct')
            .map((highlightedTexts) => {
                return highlightedTexts[0].highlightedText;
            });
    }

}
